module.exports = __webpack_public_path__ + "static/media/40.21a5bef0.jpg";